import { Route } from 'react-router';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { AUTH_STORE } from '../constants/stores';
import NotAuthorized from '../components/NotAuthorized/NotAuthorized';

const RenterProtectedRoute: React.FC<any> = ({
  component: Component,
  authStore,
  inverse,
  ...rest
}) => {
  let isRenter = !authStore.isLoadingLoggedInUser && authStore.loggedInUser.isRenter;
  if (inverse) {
    isRenter = !isRenter;
  }
  if (!isRenter) {
    return <Route {...rest} render={(props) => <NotAuthorized />} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default inject(AUTH_STORE)(observer(RenterProtectedRoute));
